export default "__VITE_ASSET__CLo6nV99__"